'use client'

import { useTranslation } from '@/hooks/client/use-translation'

import { PriceUpgradeComparator } from './price-upgrade-comparator'
import type { UpgradeComparison } from './upgrade-comparison'

interface PriceUpgradeComparisonSelectProps {
  selectedName: string
  modelName?: string
  comparisons: UpgradeComparison[]
  selectedComparison: UpgradeComparison
  onComparisonChange: (levelId: number) => void
}

export const PriceUpgradeComparisonSelect = ({
  selectedName,
  modelName,
  comparisons,
  selectedComparison,
  onComparisonChange,
}: PriceUpgradeComparisonSelectProps) => {
  const { t } = useTranslation()
  const comparisonName = modelName ? `${modelName} ${selectedComparison.levelName}` : selectedComparison.levelName

  return (
    <p className="text-navy-60 mb-2 text-xs leading-5">
      <span className="font-semibold tracking-wide uppercase">
        {t('product.upgradeHighlightsHeading', 'Upgrade Highlights:')}
      </span>{' '}
      <span className="block font-normal sm:inline">
        {comparisons.length === 1 ? (
          t('product.upgradeComparison', '{{name}} vs {{base}}', { name: selectedName, base: comparisonName })
        ) : (
          <>
            {t('product.upgradeComparedProduct', '{{name}} vs', { name: selectedName })}{' '}
            <PriceUpgradeComparator
              modelName={modelName}
              comparisons={comparisons}
              selectedComparison={selectedComparison}
              onComparisonChange={onComparisonChange}
            />
          </>
        )}
      </span>
    </p>
  )
}
